import { render, staticRenderFns } from "./Embarcacion.vue?vue&type=template&id=3c2b1337"
import script from "./Embarcacion.vue?vue&type=script&lang=js"
export * from "./Embarcacion.vue?vue&type=script&lang=js"
import style0 from "./Embarcacion.vue?vue&type=style&index=0&id=3c2b1337&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports